import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Typography, Divider } from "@material-ui/core";
import ScrollAnimation from "react-animate-on-scroll";
import "animate.css/animate.min.css";
import {
  COLOR_FONT,
  COLOR_HIGH,
  COLOR_MID,
  SPACING_BIG,
  SPACING_MED,
  SPACING_XBIG,
  SPACING_XSMALL,
} from "../constants";

const useStyles = makeStyles((theme) => ({
  root: {
    marginLeft: SPACING_MED,
    marginRight: SPACING_MED,
    marginBottom: SPACING_BIG,
    color: COLOR_FONT,
    [theme.breakpoints.up("md")]: {
      marginLeft: "15%",
      marginRight: "15%",
    },
  },
  title: {
    color: COLOR_HIGH,
    marginTop: SPACING_XBIG,
    paddingTop: SPACING_MED,
  },
  subtitle: {
    color: COLOR_MID,
    marginTop: SPACING_BIG,
    marginBottom: SPACING_XSMALL,
  },
  subtitle2: { marginTop: SPACING_XSMALL },
  subtitle3: { marginTop: SPACING_XSMALL, marginBottom: SPACING_XSMALL },
  desc: { marginTop: SPACING_XSMALL, marginBottom: SPACING_XSMALL },
}));

function Experience() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <ScrollAnimation animateIn="fadeIn" offset={50}>
        <Typography
          variant="h3"
          component="h3"
          className={classes.title}
          id={"experience"}
        >
          EXPERIENCE
        </Typography>
        <Typography variant="h4" component="h4" className={classes.subtitle}>
          Software Engineer
        </Typography>
        <Typography
          variant="body1"
          display="block"
          gutterBottom
          className={classes.subtitle2}
        >
          February 2020 - Now
        </Typography>
        <Typography
          variant="body1"
          display="block"
          gutterBottom
          className={classes.subtitle3}
        >
          Intuit, Canada
        </Typography>
        <Divider />
        <Typography
          variant="body1"
          display="block"
          gutterBottom
          className={classes.desc}
        >
          &#8226;&nbsp;Successful delivery of high quality software across the
          full stack (requirements, design, code – feature implementation &
          tests, documentation, etc.)
        </Typography>
        <Typography
          variant="body1"
          display="block"
          gutterBottom
          className={classes.desc}
        >
          &#8226;&nbsp;Working for Quickbooks Online team
        </Typography>
      </ScrollAnimation>
      <ScrollAnimation animateIn="fadeIn" offset={50}>
        <Typography variant="h4" component="h4" className={classes.subtitle}>
          Associate General Manager
        </Typography>
        <Typography
          variant="body1"
          display="block"
          gutterBottom
          className={classes.subtitle2}
        >
          January 2019 - January 2020
        </Typography>
        <Typography
          variant="body1"
          display="block"
          gutterBottom
          className={classes.subtitle3}
        >
          Best Western Diamond Inn (Family owned), Three Hills, AB, Canada
        </Typography>
        <Divider />
        <Typography
          variant="body1"
          display="block"
          gutterBottom
          className={classes.desc}
        >
          &#8226;&nbsp;Managing budgets, financial plans, and controlling
          expenditure
        </Typography>
        <Typography
          variant="body1"
          display="block"
          gutterBottom
          className={classes.desc}
        >
          &#8226;&nbsp;Recruiting, training, and managing employees
        </Typography>
        <Typography
          variant="body1"
          display="block"
          gutterBottom
          className={classes.desc}
        >
          &#8226;&nbsp;Supervising IT operations, maintenance, and contractor
          and supplier relations
        </Typography>
      </ScrollAnimation>
      <ScrollAnimation animateIn="fadeIn" offset={50}>
        <Typography variant="h4" component="h4" className={classes.subtitle}>
          Frontend Software Engineer
        </Typography>
        <Typography
          variant="body1"
          display="block"
          gutterBottom
          className={classes.subtitle2}
        >
          April 2017 - December 2018
        </Typography>
        <Typography
          variant="body1"
          display="block"
          gutterBottom
          className={classes.subtitle3}
        >
          ScribbleLive, Toronto, ON, Canada
        </Typography>
        <Divider />
        <Typography
          variant="body1"
          display="block"
          gutterBottom
          className={classes.desc}
        >
          &#8226;&nbsp;Developed content marketing application and its platform
          using React
        </Typography>
        <Typography
          variant="body1"
          display="block"
          gutterBottom
          className={classes.desc}
        >
          &#8226;&nbsp;Wrote QA tests using Jest and Cypress. Kept 80% coverage
          threshold
        </Typography>
        <Typography
          variant="body1"
          display="block"
          gutterBottom
          className={classes.desc}
        >
          &#8226;&nbsp;Published new Docker image to UAT environment by using
          CircleCI
        </Typography>
        <Typography
          variant="body1"
          display="block"
          gutterBottom
          className={classes.desc}
        >
          &#8226;&nbsp;Followed Agile software development process
        </Typography>
        <Typography
          variant="body1"
          display="block"
          gutterBottom
          className={classes.desc}
        >
          &#8226;&nbsp;Created reusable UI library using React Cosmos
        </Typography>
      </ScrollAnimation>
      <ScrollAnimation animateIn="fadeIn" offset={50}>
        <Typography variant="h4" component="h4" className={classes.subtitle}>
          IBM Master Data Management Technical Support Engineer
        </Typography>
        <Typography
          variant="body1"
          display="block"
          gutterBottom
          className={classes.subtitle2}
        >
          May 2015 - March 2017
        </Typography>
        <Typography
          variant="body1"
          display="block"
          gutterBottom
          className={classes.subtitle3}
        >
          IBM Canada Ltd, Markham, ON, Canada
        </Typography>
        <Divider />
        <Typography
          variant="body1"
          display="block"
          gutterBottom
          className={classes.desc}
        >
          &#8226;&nbsp;Provided technical support to customers for code and
          non-code defect, installation issue, performance issue, and question
          regarding product usage
        </Typography>
        <Typography
          variant="body1"
          display="block"
          gutterBottom
          className={classes.desc}
        >
          &#8226;&nbsp;Worked in debugging and investigating process
        </Typography>
        <Typography
          variant="body1"
          display="block"
          gutterBottom
          className={classes.desc}
        >
          &#8226;&nbsp;Published and maintained online external and internal IBM
          official documents, issue reports, and fix reports
        </Typography>
        <Typography
          variant="body1"
          display="block"
          gutterBottom
          className={classes.desc}
        >
          &#8226;&nbsp;Created and set virtual machines for testing and
          debugging issues
        </Typography>
        <Typography
          variant="body1"
          display="block"
          gutterBottom
          className={classes.desc}
        >
          &#8226;&nbsp;Hired immediately after internship (2013 - 2014)
        </Typography>
      </ScrollAnimation>
      <ScrollAnimation animateIn="fadeIn" offset={50}>
        <Typography variant="h4" component="h4" className={classes.subtitle}>
          Software Developer Intern
        </Typography>
        <Typography
          variant="body1"
          display="block"
          gutterBottom
          className={classes.subtitle2}
        >
          May 2012 - July 2013
        </Typography>
        <Typography
          variant="body1"
          display="block"
          gutterBottom
          className={classes.subtitle3}
        >
          Design Lore, Toronto, ON, Canada
        </Typography>
        <Divider />
        <Typography
          variant="body1"
          display="block"
          gutterBottom
          className={classes.desc}
        >
          &#8226;&nbsp;Developed and improved a web server for web applications
          by implementing a searching algorithm, creating a user-friendly
          interface, installing multi-language libraries, and debugging errors
        </Typography>
        <Typography
          variant="body1"
          display="block"
          gutterBottom
          className={classes.desc}
        >
          &#8226;&nbsp;Used PHP, MySQL, and HTML
        </Typography>
        <Typography
          variant="body1"
          display="block"
          gutterBottom
          className={classes.desc}
        >
          &#8226;&nbsp;Enhanced design of the company’s official website
        </Typography>
      </ScrollAnimation>
    </div>
  );
}

export default Experience;
